<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> 风险评估 </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <span class="page-title">前期手续</span>
      <div class="action-container">
        <a-button type="primary" class="action-btn" @click="onPass">
          评估通过
        </a-button>
        <a-button type="danger" class="action-btn" @click="onReject">
          评估不通过
        </a-button>
        <a-input placeholder="请输入复核意见" v-model="auditOpinion" class="short-text-input"/>
      </div>
    </div>
    <div class="content-container">
      <div class="container">
        <SectionThree v-bind="sectionThreeData" />
      </div>
    </div>
  </a-layout>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import {baseURL} from "@/services/HttpService";
import { loadSectionThree } from "@/services/SpecService";
import { auditSectionThree} from "@/services/DocService";
import {saveRiskAssess} from "@/services/RiskService";
import SectionThree from "@/views/SectionThree.vue";

export default {
  components: {SectionThree, BreadcrumbItem, Breadcrumb },
  data() {
    return {
      projectId: "",
      current: 2,
      headers: {
        authorization: 'authorization-text',
      },
      viewUrl: baseURL + "/attachment?fileName=",
      sectionThreeData: {
        sectionThree: {
          technicalFeasibility:"",
          costFeasibility:"",
          loanFeasibility: "",
          invoiceRatio: "",
          advanceFunding: "",
          roi:""
        },
        loadReport: {
          loading: false,
          docList: [],
          title: ""
        },
        initialDesign: {
          loading: false,
          docList: [],
          title: ""
        },
        gridIngestion: {
          loading: false,
          docList: [],
          title: ""
        },
        powerConnection: {
          loading: false,
          docList: [],
          title: ""
        },
        powerConnectionReply: {
          loading: false,
          docList: [],
          title: ""
        },
      },
      auditOpinion: ""
    };
  },
  created() {
    this.projectId = this.$route.params.id;
    console.log('projectId', this.projectId);
    if(this.projectId==='0') {
      this.projectId = "";
    } else {
      this.pageTitle = "编辑表单";
    }
  },
  mounted() {
    this.startLoadSectionThree();
  },
  methods: {
    startLoadSectionThree(){
      if(this.projectId!=="") {
        loadSectionThree(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let data = resp.data.data;
            this.sectionThreeData.sectionThree = data;

            this.buildDocList('sectionThreeData', data.loadReportDocList, 'loadReport');
            this.buildDocList('sectionThreeData', data.initialDesignDocList, 'initialDesign');
            this.buildDocList('sectionThreeData', data.gridIngestionDocList, 'gridIngestion');
            this.buildDocList('sectionThreeData', data.powerConnectionDocList, 'powerConnection');
            this.buildDocList('sectionThreeData', data.powerConnectionReplyDocList, 'powerConnectionReply');
          }
        });
      }
    },
    buildDocList(sectionName,docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[sectionName][propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    onPass() {
      let params = {
        projectId: this.projectId,
        pass: true,
        remark: this.auditOpinion
      }
      this.audit(params);
    },
    onReject() {
      let params = {
        projectId: this.projectId,
        pass: false,
        remark: this.auditOpinion
      }
      this.audit(params);
    },
    audit(params) {
      if(this.current===0){
        params.section = "sectionOne";
      }
      if(this.current===1){
        params.section = "sectionTwo";
      }
      if(this.current===2){
        params.section = "sectionThree";
      }
      saveRiskAssess(params).then(resp => {
        if (resp.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          this.$router.push({ name: "RiskReviewList" });
        } else {
          this.$message.error("操作失败:" + resp.data.errorMsg);
        }
      });
    }

  }
}
</script>
<style scoped>

</style>
